module.exports = __webpack_public_path__ + "img/COPERNIC_RC_transparent_bg-584x584.464de266.webp";